import React from 'react';

interface ServicesProps {
  onServiceClick: (service: string) => void;
}

export function Services({ onServiceClick }: ServicesProps) {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center h-[50px] flex items-center justify-center">
        <h1 className="text-xl text-white">SERVICIOS</h1>
      </div>
      
      <div className="grid grid-cols-1 gap-2">
        <button 
          onClick={() => onServiceClick('facial-hygiene')} 
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">Higiene Facial</span>
        </button>

        <button 
          onClick={() => onServiceClick('rituals')} 
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">Rituales</span>
        </button>

        <button 
          onClick={() => onServiceClick('gua-sha')} 
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">Gua Sha Facial</span>
        </button>

        <button 
          onClick={() => onServiceClick('lifting')} 
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">Lifting Facial Japonés</span>
        </button>

        <button 
          onClick={() => onServiceClick('massage')} 
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">Quiromasaje</span>
        </button>

        <button 
          onClick={() => onServiceClick('depilation')} 
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">Depilación</span>
        </button>

        <button 
          onClick={() => onServiceClick('hands-feet')} 
          className="bg-white h-[40px] rounded-lg shadow-md hover:bg-primary group transition-all flex items-center justify-center"
        >
          <span className="text-lg text-gray-600 group-hover:text-white transition-colors">Manos y Pies</span>
        </button>
      </div>
    </div>
  );
}